import { useState } from "react";

import { makeGetApiCall, makePostApiCall } from "../../../shared/makeApiCall";
import { updateObjectInArray } from "../../../shared/utility";

function parseAmount(value) {
  if (value == null || value === "") return 0;
  const amount = parseFloat(String(value).replace(/,/g, ""));
  return Number.isFinite(amount) ? amount : 0;
}

export function InventoryRawMaterialViewModel(logout) {
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState({ data: [] });
  const [productTypeOptions, setProductTypeOptions] = useState([]);

  const getInStockRawMaterial = async function (
    search,
    page,
    product_type,
    locationId,
    zoneId,
  ) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
      product_type: product_type,
      location_id: locationId || null,
      zone_id: zoneId || null,
    };
    let callResult = await makePostApiCall("getInStockRawMaterial", payload);

    if (callResult.success) {
      setProducts(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
    setLoading(false);
  };

  const getInStockRawMaterialByBomPlu = async function (id) {
    let callResult = await makePostApiCall(
      `getInStockRawMaterialByBomPlu/${id}`,
    );

    if (callResult.success) {
      return callResult;
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const onUpdateReceivingItemStock = async function (
    id,
    newInventory,
    oldInventory,
    parentIndex,
    oldItemCost,
    newItemCost,
    reason,
  ) {
    let callResult = await makePostApiCall(`updateReceivingItemStock/${id}`, {
      newInventory: newInventory,
      newItemCost: newItemCost,
      reason: reason,
    });

    if (callResult.success) {
      const currentProducts = [...products.data];
      const parent = currentProducts[parentIndex];
      if (!parent) {
        return false;
      }

      const stockDelta = parseAmount(oldInventory) - parseAmount(newInventory);
      const newTotalStock = parseAmount(parent.total_stock) - stockDelta;
      const newTotalCost = (
        parseAmount(parent.total_cost) -
        parseAmount(oldItemCost) +
        parseAmount(newItemCost)
      ).toFixed(2);
      const formattedStock = parseAmount(newInventory).toFixed(2);
      const formattedItemCost = parseAmount(newItemCost).toFixed(2);
      const subItems = (parent.subItems ?? []).map((item) =>
        String(item.id) === String(id)
          ? {
              ...item,
              in_stock: formattedStock,
              old_in_stock: formattedStock,
              total_cost: formattedItemCost,
            }
          : item,
      );

      const parentItemBeingEdited = {
        ...parent,
        subItems,
        total_stock: newTotalStock.toFixed(2),
        old_in_stock: newTotalStock,
        total_cost: newTotalCost,
      };

      var payload = {
        index: parentIndex,
        item: parentItemBeingEdited,
      };
      const newPackagingItems = updateObjectInArray(currentProducts, payload);
      setProducts({ ...products, data: newPackagingItems });
      return true;
    }

    if (callResult.errorStatus === 401) {
      logout();
    }
    return false;
  };

  const getProductTypes = async function () {
    let callResult = await makePostApiCall(`productTypesForDropdown`);

    if (callResult.success) {
      setProductTypeOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const getPromoteReceivingDefaults = async function (receivingAssemblyItemId) {
    return makeGetApiCall(
      `promoteReceivingDefaults/${receivingAssemblyItemId}`,
    );
  };

  const promoteReceivingToPackaging = async function (payload) {
    return makePostApiCall("promoteReceivingToPackaging", payload);
  };

  const exportNetSuiteRawInventoryCsv = async function () {
    let callResult = await makePostApiCall(`exportNetSuiteRawInventoryCsv`);
    if (callResult.success) {
      window.open(callResult.data.location, "_blank").focus();
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  return {
    getInStockRawMaterial,
    getInStockRawMaterialByBomPlu,
    loading,
    products,
    onUpdateReceivingItemStock,
    getProductTypes,
    productTypeOptions,
    exportNetSuiteRawInventoryCsv,
    getPromoteReceivingDefaults,
    promoteReceivingToPackaging,
  };
}
